import { throttle } from './Util.js';

const $button = $('.js-scroll-top-button');
let lastScrollTop = 0;

// если есть прилипающие блоки и нет табов, тогда делаем инит прилипающих блоков. если есть табы, то инит делаем в Tabs.js
if ($button.length) {
    App.W.on('scroll', throttle(fixedScrollTop, 100));

    $button.on('click', function () {
        $('html, body').animate({'scrollTop': 0});
    });
}

function fixedScrollTop() {
    const scrollTop = App.W.scrollTop();
    
    if (scrollTop <= 0.8*App.W.height() || scrollTop > lastScrollTop) {
        $button.addClass('_on-top');
    } else {
        $button.removeClass('_on-top');
    }

    lastScrollTop = scrollTop;
}